import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Mitch Berninger
 * id 5CFE89BB-F160-4C01-95C8-CFDF3D2099DA
 * name folder-home-outline
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-home-outline.svg
 * tags
 * - Files / Folders 
 * - Home Automation 
 */
export const FolderHomeOutlineIcon = createSvgIcon(<><path d="M20 6H12L10 4H4A2 2 0 0 0 2 6V18A2 2 0 0 0 4 20H20A2 2 0 0 0 22 18V8A2 2 0 0 0 20 6M20 18H4V8H20M13 17V14H15V17H17V13H19L14 9L9 13H11V17Z" /></>, 'FolderHomeOutlineIcon');
export default FolderHomeOutlineIcon